import api from './api';
import { REVISIONS } from '../config/Config';

const base = REVISIONS;

const list = params => api.get(base, { params });                   // e.g. { test_attempt, question }
const create = data => api.post(base, data);
const update = (id, data) => api.patch(`${base}${id}/`, data);

export default { list, create, update };